import React from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation
import type { TransformedProduct } from "../../../../product/types/productApiTypes";
import { getProductImageSource } from "../../../../product/helpers/productImgHelpers";

interface SearchResultItemProps {
  product: TransformedProduct;
  onItemClick?: () => void; // Optional: Callback when item is clicked (e.g., to close panel)
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({
  product,
  onItemClick,
}) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const currencySymbol = window.themeVariables?.currencySymbol || "₺";
  const imageSrc = getProductImageSource(product); // Use helper
  const isOutOfStock = product.stockStatus === "outofstock";

  return (
    <li className="search-result-item">
      <a
        href={product.permalink} // Change 'to' to 'href'
        className="search-result-item__link"
        onClick={onItemClick}
      >
        <img
          src={imageSrc} // Use the determined image source
          alt={product.name}
          className="search-result-item__image"
          loading="lazy"
        />
        <div className="search-result-item__details">
          <span className="search-result-item__name">{product.name}</span>
          <span className="search-result-item__price">
            {product.onSale ? (
              <>
                <span className="search-result-item__price--regular">
                  {product.formattedRegularPrice}
                  {currencySymbol}
                </span>
                <span className="search-result-item__price--sale">
                  {product.formattedSalePrice}
                  {currencySymbol}
                </span>
              </>
            ) : (
              <>
                {product.formattedPrice}
                {currencySymbol}
              </>
            )}
          </span>

          {/* Badges Container */}
          <div className="search-result-item__badges">
            {product.onSale && (
              <span className="sale-badge sale-badge-green">
                {t("common.sale")}!
              </span>
            )}
            {isOutOfStock && (
              <span className="stock-badge out-of-stock-badge">
                {t("product.outOfStock")}
              </span>
            )}
            {product.isVariable && (
              <span className="variable-badge">{t("product.variable")}</span>
            )}
          </div>
        </div>
      </a>
    </li>
  );
};

export default SearchResultItem;
